/** Planer i RCP — złożenie słowników pod `pln.*` (plik FUNDAMENTU; obszary edytują tylko swój plik). */
import { plnAlertsEn, plnAlertsPl, plnCommonEn, plnCommonPl, plnEnumsEn, plnEnumsPl, plnErrorsEn, plnErrorsPl, plnWtEn, plnWtPl } from './planner-common';
import { plnGridEn, plnGridPl } from './planner-grid';
import { plnRequestsEn, plnRequestsPl } from './planner-requests';
import { plnVacationEn, plnVacationPl } from './planner-vacation';
import { plnWorktimeEn, plnWorktimePl } from './planner-worktime';

export const plnPl = {
  common: plnCommonPl,
  enums: plnEnumsPl,
  wt: plnWtPl,
  alerts: plnAlertsPl,
  errors: plnErrorsPl,
  grid: plnGridPl,
  worktime: plnWorktimePl,
  requests: plnRequestsPl,
  vacation: plnVacationPl,
};

export const plnEn = {
  common: plnCommonEn,
  enums: plnEnumsEn,
  wt: plnWtEn,
  alerts: plnAlertsEn,
  errors: plnErrorsEn,
  grid: plnGridEn,
  worktime: plnWorktimeEn,
  requests: plnRequestsEn,
  vacation: plnVacationEn,
};
